import BeforeCard from "../components/ExampleInternetSalesHits/beforeCard";
import AfterCard from "../components/ExampleInternetSalesHits/afterCard";

const InternetSalesHits = () => (
  <div className="flex flex-col 2sm:flex-row">
    <BeforeCard />
    <AfterCard />
  </div>
);

export default InternetSalesHits;
